// AIDEV-NOTE: Shared by the `application` and `sign_in` packs — sessions#new loads a restricted pack
// set that excludes application.js (no_chrome.html.erb), which is why FormValidation and SignInTips
// are separate call sites. Keep this dependency-free plain DOM: jQuery isn't guaranteed on both.

const REGION_ID = 'caps_warning_status';

// Long enough to outlast the digits and symbols in a password, short enough that the region clears
// while the user is still on the form.
const SETTLE_MS = 800;

let settleTimer = null;

// The legacy keyCode/shiftKey heuristic: an uppercase letter with shift up, or a lowercase letter
// with shift down, means caps lock is on. `which` is the Gecko spelling of `keyCode`, and a bare
// keyCode 16 stands in for shiftKey on browsers that don't set it.
export const isCapsLockOn = (event) => {
  const charKeyCode = event.keyCode ? event.keyCode : event.which;
  const shiftKey = event.shiftKey ? event.shiftKey : (charKeyCode === 16);

  return ((charKeyCode >= 65 && charKeyCode <= 90) && !shiftKey) ||
         ((charKeyCode >= 97 && charKeyCode <= 122) && shiftKey);
};

// AIDEV-NOTE: The clear is debounced but the announcement is not, and both halves are load-bearing.
// `isCapsLockOn` classifies one character at a time, so it reports "off" for every digit and symbol
// even while caps lock is really on — typing "P4SSW0RD!" flaps on/off/on/off/on. Rewriting the region
// on each flip announces it three times for one password. Debouncing the announcement instead would
// fix the flooding but could land the first announcement after the user has already submitted.
export const announceCapsLock = (isOn) => {
  const region = document.getElementById(REGION_ID);
  if (!region) return;

  clearTimeout(settleTimer);

  if (isOn) {
    if (region.textContent === '') region.textContent = region.dataset.capsLockMessage;
    return;
  }

  settleTimer = setTimeout(() => { region.textContent = ''; }, SETTLE_MS);
};
